import { GoodsObject } from '@/models/GoodsObject';
import axios from 'axios';
import _ from 'lodash';
import store from '../store';

export class GoodsObjectService {

  static getFGPerKGRatios(goodsObject: GoodsObject, order: any) {
    const perKgRatio = goodsObject.perKgRatio;
    if(_.get(perKgRatio, 'plA.value') && _.get(order, 'product.packingMode.0.quantity')) {
      perKgRatio.plB = { value: perKgRatio.plA.value/order.product.packingMode[0].quantity };
    }
    if(_.get(perKgRatio, 'plB.value') &&  _.get(order, 'product.packingMode.1.quantity')) {
      perKgRatio.plC = { value: perKgRatio.plB.value/order.product.packingMode[1].quantity };
    } 
    return perKgRatio;
  }

  static async getWipsFromProductionReport(prodReport: any) {
    _.forEach(prodReport.process.inputs, async (input: any) => {
      if(_.get(input, 'report.replacing')) {
        try {
          const response = await axios.get(`/api/v1/goods/detail?id=${_.get(input, '_id')}`);
          const wipObject = _.get(response, 'data.data.0');
          if(wipObject) {
            const newWipGoodsObject: GoodsObject = new GoodsObject(wipObject, {} );
            store.commit('updateSingleGood', newWipGoodsObject);  
          }
        } catch (error) {
          // eslint-disable-next-line
          console.error('error', error);
        }
      }
    });
  }
}